<template>
    <a-tabs
        animated
        v-model:activeKey="page"
    >
        <a-tab-pane :key="1" tab="전체 이벤트 누적현황">

            <div style="display: flex; flex-direction: column; gap: 16px;" v-if="events.summary">
                <div class="table-responsive table-wrap table-relative">
                    <div class="table-spinner-container" v-if="dataLoading">
                        <div class="spinner"/>
                    </div>
                    <a-table class="ant-table-striped"
                            size="small"
                            bordered
                            :columns="events.selectedRound === 1 ? events.summary.firstRow.roundTwoColumns : events.summary.firstRow.roundOneColumns"
                            :data-source="events.summary.firstRow.list"
                            :pagination="false"
                            :showSorterTooltip="false"
                            v-show="!dataLoading && events.summary.firstRow.list.length > 0"
                    >
                    </a-table>

                    <div class="no-result-container" v-show="!dataLoading && events.summary.firstRow.list.length ===  0">
                        <i class="fa-solid fa-exclamation-triangle"/>
                        <span v-if="!dataLoading">{{ computedNoResultMessage }} </span>
                    </div>
                </div>
                <div class="card-body px-0 pt-0 pb-2 table-with-search">

                    <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0 ant-table-two-container" style="border: none !important;">
                        <div class="table-responsive table-wrap table-relative">
                            <div class="table-spinner-container" v-if="dataLoading">
                                <div class="spinner"/>
                            </div>
                            <div class="ant-table-two">
                                <a-table class="ant-table-striped"
                                            size="small"
                                            bordered
                                            :columns="events.summary.smilePro.columns"
                                            :data-source="events.summary.smilePro.list"
                                            :pagination="false"
                                            :showSorterTooltip="false"
                                            v-show="!dataLoading && events.summary.smilePro.list.length > 0"
                                />
                                <a-table class="ant-table-striped"
                                    size="small"
                                    bordered
                                    :columns="events.summary.smile.columns"
                                    :data-source="events.summary.smile.list"
                                    :pagination="false"
                                    :showSorterTooltip="false"
                                    v-show="!dataLoading && events.summary.smile.list.length > 0"
                                />
                                <a-table class="ant-table-striped"
                                    size="small"
                                    bordered
                                    :columns="events.summary.shared.columns"
                                    :data-source="events.summary.shared.list"
                                    :pagination="false"
                                    :showSorterTooltip="false"
                                    v-show="!dataLoading && events.summary.shared.list.length > 0"
                                />
                            </div>
        
                            <div class="no-result-container" v-show="!dataLoading &&events.list.length ===  0">
                                <i class="fa-solid fa-exclamation-triangle"/>
                                <span v-if="!dataLoading">{{ computedNoResultMessage }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; flex-direction: column; gap: 16px;" v-else>
                <div class="no-result-container">
                    <i class="fa-solid fa-exclamation-triangle"/>
                    <span>조회 기간에 대한 데이터가 없습니다.</span>
                </div>
            </div>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="일자별 통계">
            <div class="card-body px-0 pt-0 pb-2 table-with-search">

                <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0" style="border: none !important;">
                    <div class="table-responsive table-wrap table-relative">
                        <div class="table-spinner-container" v-if="dataLoading">
                            <div class="spinner"/>
                        </div>
                        <a-table class="ant-table-striped"
                                size="small"
                                bordered
                                :columns="events.dailyColumns"
                                :data-source="events.list"
                                :pagination="false"
                                :showSorterTooltip="false"
                                v-show="!dataLoading && events.list.length > 0"
                        />

                        <div class="no-result-container" v-show="!dataLoading &&events.list.length ===  0">
                            <i class="fa-solid fa-exclamation-triangle"/>
                            <span v-if="!dataLoading">{{ computedNoResultMessage }} </span>
                        </div>
                    </div>
                </div>
            </div>
        </a-tab-pane>
    </a-tabs>

</template>
<script>
import Pagination from "@/views/components/Pagination.vue";
import eventApis from "@/views/EventManagement/api";
import {
  formatCommaNumber,
  oneBtnDialog,
} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";

export default {
  components: {Pagination},
  computed: {
    noResult() {
      return !this.$store.state.isLoading && this.eventData.totalDocs === 0
    },
    computedNoResultMessage() {
        return this.$i18n.t('noresult_event');
      if(this.calledApiTimes <= 1) {
      } else {
        return this.$i18n.t('noresult_event_period');
      }
    },
    statusList() {
      return [
        {label: '전체', value: '전체'},
        {label: '예정', value: '예정'},
        {label: '진행중', value: '진행중'},
        {label: '종료', value: '종료'},
      ]
    },
    combinedData() {
      return this.eventData;
    },
    computedSelectedEventCode() {
      return this.selectedEventCode;
    },
    hasEventCodeAndData() {
        return this.computedSelectedEventCode === 'SUMMER2024' && this.combinedData;
    },
    isDataReady() {
      return this.selectedEventCode === 'SUMMER2024' && 
             Object.keys(this.eventData).length > 0 && 
             Object.keys(this.eventStatsData).length > 0;
    },
  },
  props: {
    eventData: Object,
    selectedEventId: String,
    selectedEventCode: String,
  },
  watch: {
    isDataReady: {
      handler(newValue) {
        if (newValue) {
          this.processData();
        }
      },
      immediate: true
    },
    computedSelectedEventId: {
      handler(newData) {
        if (newData) {

        }
      },
      immediate: true,
    },
    // computedSelectedEventCode: {
    //   handler(newData) {
    //     if (newData) {
    //         console.log('eventCode')
    //         if(!this.combinedData || !this.combinedData.eventStats || !this.combinedData.summary) return;
    //         this.uiHandler.processEventStats(newData);
    //     }
    //   },
    //   immediate: true,
    // },
    combinedData: {
      handler(newData) {
        if (newData) {
            console.log('data', newData)
            if(!newData.eventStats || !newData.summary) return;
            this.uiHandler.processEventStats(newData);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      formatCommaNumber,
      dateRanges: [dayjs().startOf('month'), dayjs()],
      locale,
      dataLoading: false,
      modal: {
        createEvent: {
            show: false
        },
      },
      calledApiTimes: 0,
      searchFilter: {
        keyword: {
            option: '이벤트명',
            word: ''
        },
        status: '전체',
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 'etc'],
        startContractDate: '',
        endContractDate: '',
        sort: {
            parameter: 'validationDate',
            method: 'descend'
        }
      },
      paginationData: {
            listSize: 0,
            rowsPerPage: 10,
            currentPage: 1,
            totalPages: 1,
      },
      isAllPeriodChecked: false,
      page: 1,
      events: {
        startAt: null,
        endAt: null,
        totalDocs: 0,
        list: [],
        selectedRound: -2,
        eventRounds: [],
        dailyColumns: [
            { key: 'statsDate', title: '날짜', dataIndex: 'statsDate', align: 'center', fixed: 'left',
            sorter: (a, b) => new Date(a.statsDate) - new Date(b.statsDate),
            sortDirections: ['descend', 'ascend'],
                customRender: ({text, record}) => {
                    dayjs.locale('ko')
                    const day = dayjs(text).format('dddd').split('요일')[0];
                    const dayFormatted = dayjs(text).format('YYYY/MM/DD');
                    let color = '';

                    // 토요일, 일요일 색상 지정
                    if (day === '토') {
                        color = '#278AEC';
                    } else if (day === '일') {
                        color = '#F55247';
                    }

                    return (
                        <div style="display: flex; align-items: center;">
                            <span style={{ color: color }}>{dayFormatted}</span><span style={{ color: color }}>(</span><span style={{ color: color }}>{day}</span><span style={{ color: color }}>)</span>
                        </div>
                    );
                }
            },
            {
                title: 'NFT',
                children: [
                { key: 'totalIssuedNfts', title: '총발행건', dataIndex: 'totalIssuedNfts', align: 'center' ,customRender: ({text}) => formatCommaNumber(text)},
                ],
            },
            {
                title: '수신자',
                children: [
                { key: 'receivedSmile', title: '스마일', dataIndex: 'receivedSmile', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                { key: 'receivedSmilePro', title: '스마일프로', dataIndex: 'receivedSmilePro', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                ],
            },
            {
                title: '퀴즈풀기',
                children: [
                { key: 'quizParticipated', title: '이벤트참여', dataIndex: 'quizParticipated', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                { key: 'quizSmile', title: '스마일', dataIndex: 'quizSmile', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                { key: 'quizSmilePro', title: '스마일프로', dataIndex: 'quizSmilePro', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                ],
            },
            {
                title: '친구공유',
                children: [
                { key: 'shareCountAll', title: '공유', dataIndex: 'shareCountAll', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                { key: 'shareCountSmile', title: '스마일', dataIndex: 'shareCountSmile', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                { key: 'shareCountSmilePro', title: '스마일프로', dataIndex: 'shareCountSmilePro', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                ],
            },
            {
                title: '스마일환자에게 공유받은 친구',
                children: [
                    { key: 'friendsCountAll', title: '총참여', dataIndex: 'friendsCountAll', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                    { key: 'friendsCountSmile', title: '스마일', dataIndex: 'friendsCountSmile', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                    { key: 'friendsCountSmilePro', title: '스마일프로', dataIndex: 'friendsCountSmilePro', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                ],
            },
            {
              title: 'Microsite',
              children: [
                { key: 'totalMicrosite', title: '총 방문', dataIndex: 'totalMicrosite', align: 'center', customRender: ({text}) => formatCommaNumber(text) },
                { key: 'friendsMicrosite', title: '친구 방문', dataIndex: 'friendsMicrosite', align: 'center', customRender: ({text}) => formatCommaNumber(text) },
                { key: 'normalMicrosite', title: '일반 방문', dataIndex: 'normalMicrosite', align: 'center', customRender: ({text}) => formatCommaNumber(text) },
                { key: 'proMicrosite', title: '프로 방문', dataIndex: 'proMicrosite', align: 'center', customRender: ({text}) => formatCommaNumber(text) },
              ],
            },
            {
                title: '알림톡',
                children: [
                    { key: 'resentNum', title: '재발송', dataIndex: 'resentNum', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                    { key: 'notReceived', title: '발송 실패 수', dataIndex: 'notReceived', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                    { key: 'connectedWallets', title: '지갑연결', dataIndex: 'connectedWallets', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                ],
            },
            {
                title: '일평균',
                children: [
                    { key: 'participateRatio', title: '참여율', dataIndex: 'participateRatio', align: 'center',
                        customRender: ({text, record}) => {
                            const num = Math.round(record.participateRatio * 100)
                            return `${num}%`;
                        },
                     },
                    { key: 'connectedWalletRatio', title: '지갑연결률', dataIndex: 'connectedWalletRatio', align: 'center',
                        customRender: ({text, record}) => {
                            const num = Math.round(record.connectedWalletRatio * 100)
                            return `${num}%`;
                        },
                    
                     },
                    { key: 'shareOrParticipatedRatio', title: '공유/참여', dataIndex: 'shareOrParticipatedRatio', align: 'center',
                        customRender: ({text, record}) => {
                            const num = Math.round(record.shareOrParticipatedRatio * 100)
                            return `${num}%`;
                        },

                     },
                ],
            },
        ],
        summary: {
            firstRow: {
              roundOneColumns: [
                    {
                        title: '스마일 + 스마일 프로',
                        children: [
                            { key: 'participated', title: '참여', dataIndex: 'participated', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'share', title: '공유', dataIndex: 'share', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'friends', title: '친구 참여', dataIndex: 'friends', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                        ],
                    },
                    {
                      title: 'Microsite',
                      children: [
                        { key: 'totalMicrosite', title: '전체', dataIndex: 'totalMicrosite',  align: 'center', customRender: ({text}) => formatCommaNumber(text) },
                        { key: 'normalMicrosite', title: '스마일', dataIndex: 'normalMicrosite', align: 'center', customRender: ({text}) => formatCommaNumber(text) },
                        { key: 'proMicrosite', title: '스마일 프로', dataIndex: 'proMicrosite', align: 'center', customRender: ({text}) => formatCommaNumber(text) },
                      ],
                    },
                    {
                        title: '카드발행',
                        children: [
                            { key: 'total', title: '합계', dataIndex: 'total', align: 'center' ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'totalIssuedNfts', title: '카드 수신환자', dataIndex: 'totalIssuedNfts', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'alimtalk', title: '알림톡 발송', dataIndex: 'alimtalk', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'connectedWallets', title: '지갑연결', dataIndex: 'connectedWallets', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                        ],
                    },
                    {
                        title: '참여율',
                        children: [
                            { key: 'currentRatio', title: '현재 참여율', dataIndex: 'currentRatio', align: 'center',
                              customRender: ({text, record}) => {
                                const num = Math.round(record.currentRatio * 100)
                                return `${num}%`;
                              },

                             },
                            { key: 'allPeriodRatio', title: '전체 참여율', dataIndex: 'allPeriodRatio', align: 'center',
                              customRender: ({text, record}) => {
                                const num = Math.round(record.allPeriodRatio * 100)
                                return `${num}%`;
                              },
                             },
                        ],
                    },
                ],
                roundTwoColumns: [
                    {
                        title: '스마일 + 스마일 프로',
                        children: [
                            { key: 'participated', title: '참여', dataIndex: 'participated', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'share', title: '공유', dataIndex: 'share', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'friends', title: '친구 참여', dataIndex: 'friends', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                        ],
                    },
                    {
                        title: '카드발행',
                        children: [
                            { key: 'total', title: '합계', dataIndex: 'total', align: 'center' ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'totalIssuedNfts', title: '카드 수신환자', dataIndex: 'totalIssuedNfts', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'alimtalk', title: '알림톡 발송', dataIndex: 'alimtalk', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'connectedWallets', title: '지갑연결', dataIndex: 'connectedWallets', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                        ],
                    },
                    {
                        title: '참여율',
                        children: [
                            { key: 'currentRatio', title: '현재 참여율', dataIndex: 'currentRatio', align: 'center',
                              customRender: ({text, record}) => {
                                const num = Math.round(record.currentRatio * 100)
                                return `${num}%`;
                              },

                             },
                            { key: 'allPeriodRatio', title: '전체 참여율', dataIndex: 'allPeriodRatio', align: 'center',
                              customRender: ({text, record}) => {
                                const num = Math.round(record.allPeriodRatio * 100)
                                return `${num}%`;
                              },
                             },
                        ],
                    },
                ],
                list: []
            },
            smilePro: {
                columns: [
                    {
                        title: '스마일 프로',
                        children: [
                            { key: 'issuedRatio', title: '발행 비율', dataIndex: 'issuedRatio', align: 'center',
                              customRender: ({text, record}) => {
                                const num = Math.round(record.issuedRatio * 100)
                                return `${num}%`;
                              },
                             },
                            { key: 'received', title: '수신자 수', dataIndex: 'received', align: 'center',},
                            { key: 'quizParticipatedRatio', title: '참여율', dataIndex: 'quizParticipatedRatio', align: 'center',
                              customRender: ({text, record}) => {
                                const num = Math.round(record.quizParticipatedRatio * 100)
                                return `${num}%`;
                              },
                            },
                            { key: 'quizParticipated', title: '참여', dataIndex: 'quizParticipated', align: 'center'  ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'shared', title: '공유', dataIndex: 'shared', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                            { key: 'friends', title: '친구 공유하기', dataIndex: 'friends', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                        ],
                    },
                ],
                list: [

                ]
            },
            smile: {
                columns: [
                    {
                        title: '스마일',
                        children: [
                            { key: 'issuedRatio', title: '발행 비율', dataIndex: 'issuedRatio', align: 'center',
                              customRender: ({text, record}) => {
                                const num = Math.round(record.issuedRatio * 100)
                                return `${num}%`;
                              },
                            },
                            { key: 'received', title: '수신자 수', dataIndex: 'received', align: 'center' ,customRender: ({text}) => formatCommaNumber(text)},
                            { key: 'quizParticipatedRatio', title: '참여율', dataIndex: 'quizParticipatedRatio', align: 'center',
                              customRender: ({text, record}) => {
                                const num = Math.round(record.quizParticipatedRatio * 100)
                                return `${num}%`;
                              },
                             },
                            { key: 'quizParticipated', title: '참여', dataIndex: 'quizParticipated', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                            { key: 'shared', title: '공유', dataIndex: 'shared', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                            { key: 'friends', title: '친구 공유하기', dataIndex: 'friends', align: 'center' ,customRender: ({text}) => formatCommaNumber(text) },
                        ],
                    },
                ],
                list: [

                ]
            },
            shared: {
                columns: [
                    {
                        title: '공유랭킹',
                        children: [
                            { key: 'label', title: '', dataIndex: 'label', align: 'center' ,customRender: ({text}) => formatCommaNumber(text), width: '150px'},
                            { key: 'smile', title: '스마일', dataIndex: 'smile', align: 'center' ,customRender: ({text}) => formatCommaNumber(text), width: '120px'},
                            { key: 'smilePro', title: '스마일 프로', dataIndex: 'smilePro', align: 'center' ,customRender: ({text}) => formatCommaNumber(text), width: '120px'},
                        ],
                    },
                ],
                list: [

                ]
            },
        }
      },
    }
  },
  async mounted() {
    // await this.uiHandler.search();
  },
  methods: {
    dayjs,
    ui() {
      return {
        search: async () => {
            // if(dayjs(this.events.startAt) !== dayjs(this.dateRanges[0])) {
            //     this.isAllPeriodChecked = false;
            // }
            // if(dayjs(this.events.endAt) !== dayjs(this.dateRanges[0])) {
            //     this.isAllPeriodChecked = false;
            // }
        },
        processEventStats: (data) => {
          this.events.list = data.eventStats.map(event => {
                const { statsData, ...rest } = event;
                return {
                    ...rest, 
                    ...statsData,
                    theMostSharedSmilepublishCount: statsData.theMostSharedSmile?.publishCount || '-',
                    theMostSharedSmileshareCount: statsData.theMostSharedSmile?.shareCount || '-',
                    theMostSharedSmilePropublishCount: statsData.theMostSharedSmilePro?.publishCount || '-',
                    theMostSharedSmileProshareCount: statsData.theMostSharedSmilePro?.shareCount || '-'
                };
          });
          const firstRow = {...data.summary.smileAndPro, ...data.summary.issued, ...data.summary.particpatedRatio, ...data.summary.microsite }
          this.events.summary.firstRow.list = [firstRow];
          console.log(firstRow)
          this.events.summary.smile.list = [data.summary.smile];
          this.events.summary.smilePro.list = [data.summary.smilePro];

          const shareRanks = [
                {
                label: '최다 공유 건수',
                smile: formatCommaNumber(data.summary.shareRanks.topShare.smile),
                smilePro: formatCommaNumber(data.summary.shareRanks.topShare.smilePro)
                },
                {
                label: '20회 이상 공유',
                smile: formatCommaNumber(data.summary.shareRanks.over20.smile),
                smilePro: formatCommaNumber(data.summary.shareRanks.over20.smilePro)
                },
                {
                label: '10회 이상 공유',
                smile: formatCommaNumber(data.summary.shareRanks.over10.smile),
                smilePro: formatCommaNumber(data.summary.shareRanks.over10.smilePro)
                },
                {
                label: '1회 이상 공유',
                smile: formatCommaNumber(data.summary.shareRanks.over1.smile),
                smilePro: formatCommaNumber(data.summary.shareRanks.over1.smilePro)
                }
          ];
          this.events.summary.shared.list = shareRanks;
        },
        initEventData: () => {
            this.events.list = [];
            this.events.summary.firstRow.list = [];
            this.events.summary.smile.list = [];
            this.events.summary.smilePro.list = [];
            this.events.summary.shared.list = [];
        },
        convertMonthAndYearText: (input) => {
          if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
          return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
        },
      }
    },
    api() {
      return eventApis(this.$apiInstance, this.$store);
    }
  }
}
</script>
<style lang="scss">
  @import '@/views/EventManagement/event.scss';
</style>
<style scoped lang="scss">
.search-filter-content {
  .mobile-wrap {
    display: flex;
    gap: 8px;
  }

  .mobile-no-wrap {
    display: flex;
  }
}

@media screen and (max-width: 767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range {
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .date-filter-container {
      flex-direction: row;
      border-radius: 0;
      border-bottom: 0;

      .date-filter-item {
        width: 50%;
        border-bottom: 0;
      }
    }
  }
  .container-fluid .row.justify-content-center {
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv {
    width: 100% !important;
  }
  .search-filter-title {
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap {
    width: 100%;
  }
  .search-filter-content .search-select {
    width: 100px;
  }
  .search-filter-content .search-input-container {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;

    input {
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container {
    height: auto;
  }
  .search-filter-content .date-selector-container.custom {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container {
    flex-direction: column;
  }
  .search-filter-row {
    height: auto;
  }
  .search-filter-row,
  .search-filter-content {
    flex-direction: column;
    flex: none;
  }
  .card-header {
    margin: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .search-filter-title {
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  .table-with-search .table-info-filter {
    flex-direction: column;
    width: 100%;

    .total-div {
      margin-right: auto;
    }

    .search-container {
      width: 100%;
      flex-direction: row;

      .search-select {
        margin-right: auto;
      }

      .search-div {
        flex-direction: row;
        width: 100%;

        input {
          width: calc(100% - 80px) !important;
        }

        .search-btn {
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row {
    flex-direction: column;
    height: auto;

    &:nth-of-type(2) {
      .search-filter-content {
        flex-direction: column;
      }

      .search-filter-content {
        align-items: flex-start;
      }

      .date-selector-container.custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}
</style>